export enum StorageKey {
  CookiePolicyDismissed = 'cpd',
}
